import {Component, ElementRef, ViewChild} from '@angular/core';
import { ResizeDetectionService } from '../../../services/resize-detection.service';

declare global{
  interface Window {
    Trustpilot: any
  }
}

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss']
})
export class ReviewsComponent {

  constructor (private sizedetection: ResizeDetectionService,) {

  }

  items:any = [
    {author: "Maria Magdau", title: "Absolutely in love with Nutrigenic!...", desc: "Absolutely in love with Nutrigenic! 👌 From the quality of the food to the packaging, everything is just perfect! 😍 The taste is amazing and everything is always so fresh. Since I started ordering from them, I’ve been living my healthiest lifestyle yet! 🌱💪 Thank you for making it so easy to stay on track and enjoy delicious meals! 🙏 <br/> Maria ! I highly recommend Nutrigenic 👌", read_more:0},
    {author: "Joanna Cikara", title: "Just received my first box...", desc: "Just received my first box and also just eaten two of the meals....FAB !!!! <br/> very impressed ! <br/> Good wholesome portions of the correct ingredients and nutrition . <br/> If it keeps me from cruising supermarkets aswell ...it's not expensive therefore  as you buy ten tons of what you don't need in everything in supermarkets. <br/> There's no waste either and when you put it into a lovely piece of crockery it seems gigantic the portion ...or restaurant presentation almost . <br/> Very helpful for healthy convenience eating !! <br/> Most of all hits the spot too ! 👍👌", read_more:0},
    {author: "Younes Ablouch", title: "I highly recommend [Nutrigenic]...", desc: "I highly recommend [Nutrigenic] to any athlete looking to fuel their body the right way. It’s clear they understand the demands of athletic performance and have crafted a menu that supports both the body and the taste buds.", read_more:0},
    {author: "Ajmal Khurram", title: "Honestly up there as one…", desc: "Honestly up there as one of the best meal prep companies I’ve ever tried. The quality and flavours are great.", read_more:0},
    {author: "Jason Mcdonagh", title: "Defo recommend. Food is amazing good...", desc: "Defo recommend. Food is amazing good quality and great portions the taste off food on your taste buds is a story on its own", read_more:0},
    {author: "reihane taheri", title: "The food is amazing!", desc: "The food is amazing! I liked the taste and they have a diverse menu which makes them special for me", read_more:0},
    {author: "Wael Aouini", title: "I’ve tried this meals...", desc: "I’ve tried this meals and I am extremely satisfied, finally I can enjoy quality healthy food. <br/>The best", read_more:0},
    {author: "H AR", title: "If you want to stay fit...", desc: "If you want to stay fit and eat varied and delicious quality food but don’t have time to cook NutriGenic is the best solution!!", read_more:0},
    {author: "Imran Lasker", title: "I’ve tried so many meal…", desc: "I’ve tried so many meal prep companies and this is the one that makes the most sense! Absolutely love it", read_more:0},
  ];

  isTablet: boolean = false;
  isMobile: boolean = false;
  isDesktop: boolean = false;

  @ViewChild('trustbox') trustboxRef!: ElementRef;


  ngOnInit() {
    this.sizedetection.refreshSize();
    this.sizedetection.sizeCondition$.subscribe(data => {
      this.isDesktop = data.isDesktop;
      this.isTablet = data.isTablet;
      this.isMobile = data.isMobile;
    });
    this.items.forEach((element:any) => {
      element.title = element.title.substring(0, 30);
      element.desc2 = element.desc.substring(0, 60) + "...";
    });
  }

  ngAfterViewInit(): void {
    window.Trustpilot?.loadFromElement(this.trustboxRef.nativeElement, true);
  }

  showMore(item: any, event: any) {
    event.stopPropagation();
    event.preventDefault();
    item.desc2 = item.desc;
    item.read_more = 1;
  }

  readLess(item: any, event: any) {
    event.stopPropagation();
    event.preventDefault();
    item.desc2 = item.desc.substring(0, 60) + "...";
    item.read_more = 0;
  }
}
